import { render, staticRenderFns } from "./GettingStarted.vue?vue&type=template&id=298787d2&"
import script from "./GettingStarted.vue?vue&type=script&lang=js&"
export * from "./GettingStarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCardText,VCol,VContainer,VListItem,VListItemContent,VListItemTitle,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/engines2k/repos/eep/fe-seo-team-flow/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('298787d2')) {
      api.createRecord('298787d2', component.options)
    } else {
      api.reload('298787d2', component.options)
    }
    module.hot.accept("./GettingStarted.vue?vue&type=template&id=298787d2&", function () {
      api.rerender('298787d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Dashboard/GettingStarted.vue"
export default component.exports